import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/helpers/utils';
import SvgPlay from './svg/SvgPlay';

type PlayButtonProps = ComponentPropsWithoutRef<'button'> & {
    className?: string;
};

export default function PlayButton({ className = '', ...rest }: PlayButtonProps) {
    return (
        <button
            {...rest}
            className={cn(
                'w-28 h-28 md:w-32 md:h-32 bg-linear-to-tr from-accent-color to-accent-color/50 mouse-hover:bg-purple-800/50 transition-all duration-500 mouse-hover:scale-110 inline-flex items-center justify-center rounded-full text-white will-change-transform',
                className
            )}
        >
            <SvgPlay className="w-[25px] h-[37px] md:w-[29px] md:h-[42px] relative left-1" />
        </button>
    );
}
